var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9a7 7 0 107 7 7.008 7.008 0 00-7-7zm.146 2.917a.875.875 0 110 1.75.875.875 0 010-1.75zm1.312 7.875h-2.333a.583.583 0 010-1.167h.438c.08 0 .145-.065.145-.146v-2.625a.146.146 0 00-.146-.146h-.437a.583.583 0 110-1.166h.583c.645 0 1.167.522 1.167 1.166v2.771c0 .08.065.146.146.146h.437a.583.583 0 110 1.167z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgInfo;